export default __webpack_public_path__ + "assets/front/scss/collaborative-indexation.4c4a626e033bdcf8a95dd03a9f64062e.css";